import { coletarEstadosFormulas } from '@shared/components/formula/utils/formula-estados.util';
import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgxCurrencyDirective } from 'ngx-currency';
import { AlertCardComponent } from '@shared/components/alert-card/alert-card.component';
import { AtivacaoSectionCardComponent } from '@shared/components/ativacao-section-card/ativacao-section-card.component';
import { MaskService } from '@shared/services/mask.service';
import { FormulaEditorDialogComponent, FormulaEditorDialogData, FormulaEditorDialogResult } from '@shared/components/formula/formula-editor-dialog/formula-editor-dialog.component';
import { FormulaItemStruct } from '@shared/services/structs/formula/formula-item.struct';
import { TipoFormulaEnum } from '@shared/enums/formula/tipo-formula.enum';
import { FormulaCatalogoItemStruct } from '@shared/services/structs/formula/formula-catalogo-item.struct';
import { FormulaCatalogoService } from '@shared/services/apis/motor-fiscal/formula-catalogo.service';

/**
 * Seção Base de Cálculo Compartilhada da aba IBS/CBS: a vBC é apurada uma única vez por item
 * e vale para as seções de CBS, IBS UF e IBS Município. Além da personalização da fórmula, tem o
 * card do redutor da base (percentualReducaoBaseCalculo), pré-ligado pelo indicador do CST.
 */
@Component({
    selector: 'app-regra-tributaria-base-calculo-section',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatIconModule,
        MatButtonModule,
        MatBadgeModule,
        MatFormFieldModule,
        MatInputModule,
        NgxCurrencyDirective,
        AlertCardComponent,
        AtivacaoSectionCardComponent,
    ],
    templateUrl: './regra-tributaria-base-calculo-section.component.html',
    styleUrl: './regra-tributaria-base-calculo-section.component.css',
})
export class RegraTributariaBaseCalculoSectionComponent {
    @Input({ required: true }) form!: FormGroup;
    @Input() formulas: FormulaCatalogoItemStruct[] = [];

    public readonly percentMask = inject(MaskService).getPercentMask();

    public get reducaoBaseCalculoControl(): FormControl {
        return this.form.get('reducaoBaseCalculoAtivo') as FormControl;
    }

    public get estadosControl(): FormControl {
        return this.form.get('_estadosFormulas') as FormControl;
    }

    constructor(
        private dialog: MatDialog,
        private formulaCatalogoService: FormulaCatalogoService,
    ) {}

    public get personalizadasCount(): number {
        const estados = (this.estadosControl?.value as FormulaItemStruct[]) ?? [];
        return estados.filter(e => e.tipo === TipoFormulaEnum.Personalizada).length;
    }

    public abrirEditorFormulas(): void {
        const data: FormulaEditorDialogData = {
            titulo: 'Base de Cálculo Compartilhada',
            formulas: this.formulas,
            estadosIniciais: (this.estadosControl?.value as FormulaItemStruct[]) ?? [],
            estadosFormulasAgregados: coletarEstadosFormulas(this.form),
            contextoRaiz: 'regra-tributaria',
            validarPersonalizacoes: request => this.formulaCatalogoService.validarPersonalizacoes(request),
        };
        const ref = this.dialog.open(FormulaEditorDialogComponent, { width: '900px', maxWidth: '96vw', maxHeight: '92vh', data });
        ref.afterClosed().subscribe((result: FormulaEditorDialogResult | null) => {
            if (result) {
                this.estadosControl.setValue(result.formulas);
            }
        });
    }
}
